import { render, staticRenderFns } from "./TableRowNumInjectionsPerTech.vue?vue&type=template&id=179ea37f&lang=pug&"
import script from "./TableRowNumInjectionsPerTech.vue?vue&type=script&lang=js&"
export * from "./TableRowNumInjectionsPerTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179ea37f')) {
      api.createRecord('179ea37f', component.options)
    } else {
      api.reload('179ea37f', component.options)
    }
    module.hot.accept("./TableRowNumInjectionsPerTech.vue?vue&type=template&id=179ea37f&lang=pug&", function () {
      api.rerender('179ea37f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/table-rows/TableRowNumInjectionsPerTech.vue"
export default component.exports